import i18next, { type TOptions } from 'i18next';
import { type Translations } from '../types/Translations';

export const initI18n = (lng = 'en', resources: Translations): void => {
  i18next.init({
    lng,
    fallbackLng: 'en',
    keySeparator: '$',
    interpolation: {
      escapeValue: false,
    },
    resources: {
      [lng]: {
        translation: resources,
      },
    },
  });
};

export const t = (key: string, params?: TOptions): string => {
  return i18next.t(key, params);
};
